const data = (
  collection,
  keyword,
  planStatus,
  renewalMethod,
  renewalPeriod
) => {
  return (
    collection &&
    Object.values(collection).filter((item) => {
      let available = false;

      if (
        item.attributes.enterprise_name
          .toLowerCase()
          .includes(keyword.toLowerCase()) &&
        (planStatus == "" || item.attributes.status == planStatus) &&
        item.attributes.renewal_method.includes(renewalMethod) &&
        (renewalPeriod == "" ||
          (renewalPeriod != "" &&
            item.attributes.renewal_date_starts_in > 0 &&
            item.attributes.renewal_date_starts_in <= parseInt(renewalPeriod)))
      )
        available = true;

      return available;
    })
  );
};

export default data;
